module.exports = __webpack_public_path__ + "static/media/gift-card.f4850e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/gift-card.jpg
// module id = 511
// module chunks = 0